<template>
  <div>
    <v-row class="py-0">
      <v-col
        class="py-0"
        cols="12"
        sm="4"
      >
        <v-text-field
          :value="bike.manafacturer"
          :rules="[v => !!v || 'Manufacturer is required']"
          label="Manufacturer"
          hint="This is normally the largest writing on your frame, for example TREK"
          outlined
          required
          dense
          disabled
          @input="$emit('bikeUpdate', { value: $event, key: 'manafacturer' })"
        />
      </v-col>
      <v-col
        v-if="!bike.unknown_details"
        class="py-0"
        cols="12"
        sm="4"
      >
        <v-select
          :value="bike.model"
          :items="['H2L', 'H6L', 'M2L', 'M6L']"
          :rules="[v => !!v || 'Model is required']"
          hint="Can often be found on the top tube or seat tube in smaller writing"
          label="Model"
          required
          outlined
          dense
          @change="$emit('bikeUpdate', { value: $event, key: 'model' })"
        />
      </v-col>
      <v-col
        class="py-0"
        cols="12"
        sm="4"
      >
        <v-select
          :value="bike.colour"
          :items="['Black', 'Bolt Blue', 'Turkish Green']"
          :rules="[v => !!v || 'Colour is required']"
          hint="The colour of the bicycle, will help us identify it."
          label="Colour"
          required
          outlined
          dense
          @change="$emit('bikeUpdate', { value: $event, key: 'colour' })"
        />
      </v-col>
    </v-row>

    <v-row class="py-0 mb-6">
      <v-col
        class="py-0"
        cols="12"
      >
        <v-checkbox
          :input-value="bike.unknown_details"
          class="mb-0"
          label="I don't know my bike's model"
          @change="$emit('bikeUpdate', { value: $event, key: 'unknown_details' });"
        />
<!--         <v-checkbox
          :input-value="bike.is_electric"
          class="mt-0"
          label="My bike is electric"
          @change="$emit('bikeUpdate', { value: $event, key: 'is_electric' }); trackServices()"
        /> -->
      </v-col>
    </v-row>

    <v-row class="py-0">
      <v-col
        v-if="bike.job_type === 'JOB_TYPE_C&R'"
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="bike.additional_authorised_spend"
          type="number"
          min="0"
          prefix="£"
          label="Authorised Extra Spend"
          hint="If your bike needs parts, how much extra are you willing to spend without us calling you"
          persistent-hint
          outlined
          dense
          @input="$emit('bikeUpdate', { value: $event, key: 'additional_authorised_spend' })"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-textarea
          :value="bike.customer_notes"
          :required="bike.service_sku === 'fix_me_fit_me'"
          :rules="notesRules"
          label="Notes"
          outlined
          dense
          hint="Any additional notes that will help our mechanics, or tell us about any issues you want us to look at."
          persistent-hint
          @input="$emit('bikeUpdate', { value: $event, key: 'customer_notes' })"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import filter from 'lodash.filter'
import find from 'lodash.find'
import orderBy from 'lodash.orderby'

export default {
  name: 'BikeForm',

  props: {
    bike: {
      type: Object,
      required: true
    },

    services: {
      type: Array,
      required: true
    },

    position: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      //
    }
  },

  mounted () {
    this.trackServices()
  },

  computed: {
    availableServices () {
      return orderBy(this.bike.is_electric ? this.electricServices : this.normalServices, 'price')
    },

    normalServices () {
      return filter(this.services, { electric: false })
    },

    electricServices () {
      return filter(this.services, { electric: true })
    },

    notesRules () {
      if (this.bike.service_sku === 'fix_me_fit_me') {
        return [v => !!v || 'Notes are required for this service type']
      }
      return []
    }
  },

  methods: {
    trackServices () {
      var formattedServices = []
      this.availableServices.forEach((service, key) => {
        formattedServices.push({
          name: service.name,
          id: service.sku,
          price: service.price,
          brand: 'havebike',
          category: 'Service',
          list: this.bike.is_electric ? 'Electric' : 'Regular',
          position: (key + 1) + ((this.position - 1) * this.availableServices.length)
        })
      })
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'GBP',
          impressions: formattedServices
        }
      })
    },

    trackServiceClick (sku) {
      var service = find(this.services, { sku: sku })
      window.dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            actionField: { list: this.bike.is_electric ? 'Electric' : 'Regular' },
            products: [{
              name: service.name,
              id: service.sku,
              price: service.price,
              brand: 'havebike',
              category: 'Service',
              position: this.position
            }]
          }
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
  .most_popular {
    position: absolute;
    right: 0;
    width: 150px;
  }
  .service_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .service_img {
    object-fit: cover;
  }
</style>
